/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CabinClass,
    CabinClassFromJSON,
    CabinClassFromJSONTyped,
    CabinClassToJSON,
} from './';

/**
 * 
 * @export
 * @interface CabinClassCriteriaDto
 */
export interface CabinClassCriteriaDto {
    /**
     * 
     * @type {CabinClass}
     * @memberof CabinClassCriteriaDto
     */
    value?: CabinClass;
    /**
     * 
     * @type {boolean}
     * @memberof CabinClassCriteriaDto
     */
    exclude?: boolean;
}

export function CabinClassCriteriaDtoFromJSON(json: any): CabinClassCriteriaDto {
    return CabinClassCriteriaDtoFromJSONTyped(json, false);
}

export function CabinClassCriteriaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinClassCriteriaDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : CabinClassFromJSON(json['value']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function CabinClassCriteriaDtoToJSON(value?: CabinClassCriteriaDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': CabinClassToJSON(value.value),
        'exclude': value.exclude,
    };
}


